import { CountryCodes } from '../types/CountryCodes'; // NOTE: circular dependency
import { Region } from '../types/Region'; // NOTE: circular dependency

// SOURCE: https://github.com/melwynfurtado/postcode-validator/blob/master/src/postcode-regexes.ts
export const zipCodePerCountry: Record<
  CountryCodes,
  { length: number; pattern: RegExp }
> = {
  [CountryCodes.AT]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.AU]: { length: 8, pattern: /^\d{0,4}(?:\s?-\s?\d{0,4})?$/ },
  [CountryCodes.BA]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.BE]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.BG]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.BR]: { length: 9, pattern: /^\d{0,5}-?\d{0,3}$/ },
  [CountryCodes.CA]: { length: 7, pattern: /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i },
  [CountryCodes.CH]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.CN]: { length: 6, pattern: /^\d{0,6}$/ },
  [CountryCodes.CZ]: { length: 6, pattern: /^\d{0,3}(?:\s\d{0,2})?$/ },
  [CountryCodes.DE]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.DK]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.EE]: { length: 5, pattern: /^\d{5}$/ },
  [CountryCodes.ES]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.FI]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.FR]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.GB]: {
    length: 8, // 6-8
    pattern: /^[A-Z]{0,2}[0-9]{0,1}[A-Z0-9]{0,1}(?:\s[0-9]{0,1}[A-Z]{0,2})?$/,
  },
  [CountryCodes.GR]: { length: 5, pattern: /^\d{3}[ ]?\d{2}$/ },
  [CountryCodes.HR]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.HU]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.IE]: {
    length: 8,
    pattern:
      /^([AC-FHKNPRTV-Y]{0,1}[0-9]{0,2}|D6W)(?:\s[0-9AC-FHKNPRTV-Y]{0,4})?$/,
  },
  [CountryCodes.IT]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.KR]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.LU]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.LV]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.MC]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.MX]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.MY]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.NL]: { length: 6, pattern: /^\d{0,4} ?[A-Z]{0,2}$/ },
  [CountryCodes.NO]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.NZ]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.PL]: { length: 6, pattern: /^\d{0,2}(?:-\d{0,3})?$/ },
  [CountryCodes.PT]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.RO]: { length: 6, pattern: /^\d{0,6}$/ },
  [CountryCodes.SE]: { length: 5, pattern: /^\d{0,3}(?:\s\d{0,2})?$/ },
  [CountryCodes.SG]: { length: 6, pattern: /^\d{0,6}$/ },
  [CountryCodes.SI]: { length: 4, pattern: /^\d{0,4}$/ },
  [CountryCodes.SK]: { length: 6, pattern: /^\d{0,3}(?:\s\d{0,2})?$/ },
  [CountryCodes.TH]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.TR]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.TW]: { length: 3, pattern: /^\d{0,3}(?:\d{0,2})?$/ },
  [CountryCodes.UA]: { length: 5, pattern: /^\d{0,5}$/ },
  [CountryCodes.US]: { length: 10, pattern: /^\d{0,5}(?:-\d{0,4})?$/ },
  [CountryCodes.ZA]: { length: 4, pattern: /^\d{0,4}$/ },
};

export function validateZipCode(region: Region) {
  const zipCodeForCountry = zipCodePerCountry[region.country];
  const isValid = zipCodeForCountry.pattern.test(region.zipCode);
  const isPrefix = region.zipCode.length < zipCodeForCountry.length;
  const isFullAndValid = isValid && !isPrefix;
  const isPrefixAndValid = isValid && isPrefix;
  return { isValid, isFullAndValid, isPrefixAndValid };
}
